import { SEO } from "@/lib/seo";
import { PageHero } from "@/components/common/PageHero";

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <SEO title="Terms & Conditions" description="Terms & Conditions for WomensMatchDayLive." path="/terms" />
      <PageHero eyebrow="Legal" title="Terms & Conditions" crumbLabel="Terms & Conditions" />
      <section className="bg-white py-16">
        <div className="mx-auto max-w-3xl space-y-8 px-6 lg:px-12">
          {["Acceptance of Terms", "Use of This Website", "Intellectual Property", "Liability", "Contact Us"].map((heading) => (
            <div key={heading}>
              <h2 className="font-heading text-2xl uppercase text-brand-black">{heading}</h2>
              <p className="mt-2 text-black/60">Text goes here</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
